const WARNING_HTML = `
  <div id="cart-restriction-warning" style="
    background:#fff3cd;border:1px solid #ffc107;border-radius:4px;
    padding:12px 16px;margin-bottom:16px;font-size:14px;line-height:1.8;
  ">
    ⚠️ <strong>同時注文・同時発送について</strong><br>
    商品と発送の都合上、おせち商品は他の商品との同時発送・同時注文は致しかねます。<br>
    恐れ入りますが、別々にご注文ください。
  </div>
`;

// ↓ Step1で確認したhandleに変更
const COLLECTION_HANDLE = '明神館のおせち';

async function checkCartRestriction() {
  const [cartRes, colRes] = await Promise.all([
    fetch('/cart.js'),
    fetch(`/collections/${COLLECTION_HANDLE}/products.json?limit=250`)
  ]);
  const cart = await cartRes.json();
  const col = await colRes.json();

  if (cart.items.length < 2) { clearWarning(); disableCheckout(false); return; }

  const osechiHandles = new Set(col.products.map(p => p.handle));
  const cartHandles = cart.items.map(i => i.handle);

  const hasOsechi = cartHandles.some(h => osechiHandles.has(h));
  const hasOther  = cartHandles.some(h => !osechiHandles.has(h));

  if (hasOsechi && hasOther) { showWarning(); disableCheckout(true); }
  else { clearWarning(); disableCheckout(false); }
}

function showWarning() {
  if (document.getElementById('cart-restriction-warning')) return;
  const target = document.querySelector('form[action="/cart"]') || document.querySelector('.cart__footer');
  if (target) target.insertAdjacentHTML('beforebegin', WARNING_HTML);
}
function clearWarning() {
  const el = document.getElementById('cart-restriction-warning');
  if (el) el.remove();
}
function disableCheckout(disabled) {
  const btn = document.querySelector('[name="checkout"], .cart__checkout-button, #checkout');
  if (!btn) return;
  btn.disabled = disabled;
  btn.style.opacity = disabled ? '0.5' : '';
  btn.style.cursor  = disabled ? 'not-allowed' : '';
}

if (window.location.pathname === '/cart') {
  document.addEventListener('DOMContentLoaded', checkCartRestriction);
  document.addEventListener('change', e => {
    if (e.target.matches('[name="updates[]"]')) setTimeout(checkCartRestriction, 600);
  });
  document.addEventListener('cart:updated', checkCartRestriction);
}
